import { CommonPageWrapper, HeadingWrapper } from 'admin/components/wrappers';
import { AdminSearch } from 'app/components/AdminSearchField';
import CustomBreadCrumb from 'app/components/CustomBreadCrumb';
import { PageMainLabel } from 'app/components/SHLabel';
import { TableSkeletonLoader } from 'app/components/TableSkeletonLoader';
import { usePermission } from 'hooks/usePermission';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import FeeManagementTable from './FeeManagementTable';
import usePaymentApi from 'hooks/usePaymentApi';

type Props = {};
const breadCrumbItems = [
    {
        id: '',
        text: 'Showyeda admin',
        disabled: true,
    },
    {
        id: '/admin/settings',
        text: 'Settings',
    },
    {
        id: '',
        text: 'Fee Management',
        disabled: true,
    },
];
const FeeManagementPage = (props: Props) => {
    const { hasViewPermission } = usePermission();
    const { getPaymentPlansList, paymentPlansList, loading, updatePaymentPlan } =
        usePaymentApi();
    const [searchTerm, setSearchTerm] = useState<string>('');
    const handleSearch = e => {
        setSearchTerm(e.target.value);
    };
    useEffect(() => {
        getPaymentPlansList();
    }, []);
    return (
        <>
            <CommonPageWrapper>
                <HeadingWrapper>
                    <PageMainLabel>Fee Management</PageMainLabel>
                    <CustomBreadCrumb preData={breadCrumbItems} />
                </HeadingWrapper>
                <HeadingWrapper>
                    <ButtonWrapper>
                        <div style={{ width: '283px', paddingTop: '10px' }}>
                            <AdminSearch
                                placeholder="Search by plan type"
                                onSearchTextEntering={handleSearch}
                                searchTerm={searchTerm}
                                setSearchTerm={setSearchTerm}
                            />
                        </div>
                    </ButtonWrapper>
                </HeadingWrapper>
                {hasViewPermission('0900101011') && (
                    <>
                        {loading ? (
                            <TableSkeletonLoader
                                rowContent={8}
                                width={100}
                                headingWidth={80}
                            />
                        ) : (
                            <FeeManagementTable
                                paymentPlansList={paymentPlansList}
                                updatePaymentPlan={updatePaymentPlan}
                                getPaymentPlansList={getPaymentPlansList}
                                searchTerm={searchTerm}
                            />
                        )}
                    </>
                )}
            </CommonPageWrapper>
        </>
    );
};

export default FeeManagementPage;
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
  width: 100%;
  gap: 10px;
  align-items: baseline;
  .field-style {
    display: flex;
  }
`;
